import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';
import { BaseDataResponse, BaseResponse } from '@/type';
import { mock } from '@/common/consts';

interface ShowPageResponse {
    show: boolean;
    perStatus: number; // 个人审核状态：0：未激活；1：未认证；2：审核通过；3：已提交待审核；4：审核不通过
    entStatus: number; // 审核状态：0：未激活；1：未认证；2：已完成企业信息填写；3：企业认证通过；4：企业认证失败审核不通过
    changePhone: boolean; // 更换手机号
    changeAdmin: boolean; // 更换管理员
}
type ShowPageResponseType = BaseDataResponse<ShowPageResponse>;

export interface FinanceListInfoItemType {
    settlementId: string;
    date: number;
    sumcashamt: number;
    cptaxratio: string;
    cptaxes: string;
    settlementamount: string;
    status: number;
    settlementBillType: string;
    settlementBillTypeCode: string;
    frozenAmount: number;
    dataType: 0 | 1; // 0 旧数据；1: 主体维度新数据，不能操作，只能去主体维度查看
}
interface FinanceListInfo {
    paymentList: FinanceListInfoItemType[];
}
type FinanceListInfoType = BaseDataResponse<FinanceListInfo>;

interface PerRealynameInfo {
    id: string;
    name: string;
    phone: string;
}
type PerRealynameInfoType = BaseDataResponse<PerRealynameInfo>;

interface RealynameUrl {
    realynameUrl: string;
    exists: boolean;
}
type PerRealynameUrlType = BaseDataResponse<RealynameUrl>;

interface PerCheckStatus {
    perStatus: number; // 个人审核状态：0：未激活；1：未认证；2：审核通过；3：已提交待审核；4：审核不通过
}
type PerCheckStatusType = BaseDataResponse<PerCheckStatus>;

interface EntCheckStatus {
    entStatus: number; // 审核状态：0：未激活；1：未认证；2：已完成企业信息填写；3：企业认证通过；4：企业认证失败审核不通过
}
type EntCheckStatusType = BaseDataResponse<EntCheckStatus>;

interface ContractSign {
    allow: boolean;
    signUrl: string; // 协议签署链接
    message: string;
}
type ContractSignType = BaseDataResponse<ContractSign>;

interface ContractStatus {
    signStatus: number; // 0签署中 1已删除 2已完成 3已撤销 4已拒签 5已过期
}
type ContractStatusType = BaseDataResponse<ContractStatus>;

interface EntRealynameInfo {
    companyName: string; // 企业名称
    creditNo: string; // 统一社会信用代码
    legalName: string; // 法人
    licensePath: string; // 营业执照 /account/file/img/licensePath
    bankCardName: string; // 持卡人姓名
    bankCardNo: string; // 银行卡账号
    bankBranch: string; // 开户支行
    bankName: string; // 银行
    bankCity: string; // 开户行所在地
}
type EntRealynameInfoType = BaseDataResponse<EntRealynameInfo>;

export interface DetailPaymentListItem {
    date: number;
    billname: string; // 游戏名称
    platform: string; // 平台
    settlementtype: string; // 类型
    cooperationtype: string; // 合作类型
    sumcashamt: number; // 流水合计
    cptaxratio: string; // 税费率
    cppassagefee: string; // 渠道费率
    cpbaseamount: string; // 分成比例
    settlementamount: number; // 结算金额
}
interface DetailInfo {
    paymentList: DetailPaymentListItem[];
    billnumber: string; // '结算单号',
    billDate: string; // '结算时间',
    billname: string; // '结算名称',
    invoicetype: string; // '发票类型',
    invoicecontent: string; // '发票内容',
    ourcompanyname: string; // '公司名称',
    ourtaxpayeridentificationnumber: string; // '纳税人识别码',
    ouraddress: string; // '注册地址',
    phone: string; // '电话',
    bankBranch: string; // '开户行',
    bankCardNo: string; // '账号',
    customername: string; // '合作方信息-公司名称',
    customerBank: string; // '合作方信息-开户银行',
    customerbankaccount: string; // '合作方信息-账号',
    recipientname: string; // '邮寄-收件人',
    recipienttel: string; // '邮寄-联系电话',
    recipientaddress: string; // '邮寄-地址'
}
type DetailInfoType = BaseDataResponse<DetailInfo>;

type MoneyCheckType = BaseDataResponse<{
    checkStatus: boolean;
    remainTimes: number;
}>;

interface InvoiceInfo {
    invoiceContentType: number;
    invoiceType: number;
    remainUpdateTimes: number;
    updateEnable: boolean;
    updateUnableTips: string;
}

type InvoiceInfoType = BaseDataResponse<InvoiceInfo>;

// export const ListStatus = ['待确认', '待打款', '已打款'];

enum STATUS {
    TOBECONFIRMED = 0,
    TOBEPAID = 1,
    ALREADYPAID = 2,
    TOBECHARGE = 10,
    CHARGING = 11,
    ALREADYCHARGE = 12,
    ALLCHARGED = 13,
}

export const ListStatus: { [key in STATUS]: string} = {
    0: '待确认',
    1: '待打款',
    2: '已打款',
    10: '待充值',
    11: '充值中',
    12: '已充值',
    13: '已全部放款',
};

export const SettlementamountFilter: { [k: string]: string } = {
    MONTHLY: '月结结算单',
    DAILY: '日结结算单',
    DAILY_LIGATION_DIFFERENCE: '日结轧差结算单',
    DAILY_MONTHLY_ADJUSTMENT: '日结-月调整结算单'
}

export class GameFinanceModel extends BaseModel {
    // 1 用于判断自助结算页对当前用户是否可见
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/showpage',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    showPageMutation!: MutationResult<
        Record<string, string>,
        ShowPageResponseType
    >;
    async getAuth(p: Record<string, string>) {
        await this.showPageMutation.mutate(p);
    }
    get isShowTab() {
        return this.showPageMutation.data.data?.show || false;
    }
    get pageStatus() {
        return (
            this.showPageMutation.data.data || {
                perStatus: 0, // 个人审核状态：0：未激活；1：未认证3过；3：已提交待审核；4：审核不通过
                entStatus: 0, // 审核状态：0：未激活；1：未认证；2：已完成企业信息填写；3：企业认证通过；4：企业认证失败审核不通过
                changePhone: false, // 更换手机号
                changeAdmin: false,
            }
        );
    }

    // 2 审核通过后，自助结算列表
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/listinfo',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    listInfoMutation!: MutationResult<
        Record<string, string | number>,
        FinanceListInfoType
    >;

    async getList(p: Record<string, string | number>) {
        await this.listInfoMutation.mutate(p);
    }
    get list() {
        return this.listInfoMutation.data.data?.paymentList || [];
    }

    // 3 电签个人实名信息获取
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/per/realynameInfo',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    perRealynameInfoMutation!: MutationResult<
        Record<string, string>,
        PerRealynameInfoType
    >;

    async getPerRealynameInfo(p: Record<string, string>) {
        await this.perRealynameInfoMutation.mutate(p);
    }
    get manager() {
        return (
            this.perRealynameInfoMutation.data.data || {
                id: '',
                name: '',
                phone: '',
            }
        );
    }

    // 4 提交电签个人实名认证，拿到电签实名认证页面的url，跳过去
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/per/realyname',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    perRealynameUrlMutation!: MutationResult<
        Record<string, string>,
        PerRealynameUrlType
    >;

    async getRealynameUrl(p: Record<string, string>): Promise<string> {
        await this.perRealynameUrlMutation.mutate(p);
        return this.perRealynameUrlMutation.data.data?.realynameUrl || '';
    }

    get isPerExist() {
        return this.perRealynameUrlMutation.data.data?.exists || false;
    }

    // 5 个人实名认证结果状态查询
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/per/checkstatus',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    perCheckStatusMutation!: MutationResult<
        Record<string, string>,
        PerCheckStatusType
    >;

    async perCheckStatus(p: Record<string, string>) {
        await this.perCheckStatusMutation.mutate(p);
    }

    // 6企业实名信息获取
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/ent/realynameInfo',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    entRealynameInfoMutation!: MutationResult<any, EntRealynameInfoType>;

    async entRealynameInfo(p: Record<string, string>) {
        await this.entRealynameInfoMutation.mutate(p);
    }
    get enterPrise() {
        return (
            this.entRealynameInfoMutation.data?.data || {
                companyName: '',
                creditNo: '',
                legalName: '',
                licensePath: '', //  /account/file/img/licensePath
                bankCardName: '',
                bankCardNo: '',
                bankBranch: '',
                bankName: '',
                bankCity: '',
            }
        );
    }

    // 7 提交企业实名认证
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/ent/realyname',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    entRealynameMutation!: MutationResult<Record<string, string>, BaseResponse>;

    async entRealyname(p: Record<string, string>) {
        await this.entRealynameMutation.mutate(p);
    }

    // 8 企业实名认证-认证状态查询
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/ent/checkstatus',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    entCheckStatusMutation!: MutationResult<
        Record<string, string>,
        EntCheckStatusType
    >;

    async entCheckStatus(p: Record<string, string>) {
        await this.entCheckStatusMutation.mutate(p);
    }

    // 9 金额回填验证
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/money/check',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    moneyCheckMutation!: MutationResult<
        Record<string, string | number>,
        MoneyCheckType
    >;

    async moneyCheck(p: Record<string, string | number>) {
        await this.moneyCheckMutation.mutate(p);
    }

    // 10 结算单签署接口
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/contract/sign',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    contractSignMutation!: MutationResult<
        Record<string, string | number>,
        ContractSignType
    >;

    async contractSign(
        p: Record<string, string | number>,
    ): Promise<ContractSign> {
        await this.contractSignMutation.mutate(p);
        return this.contractSignMutation.data.data;
    }
    // 14 结算单详情查询接口
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/detailInfo',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    detailInfoMutation!: MutationResult<
        Record<string, string | number>,
        DetailInfoType
    >;

    async getDetailInfo(p: Record<string, string | number>) {
        await this.detailInfoMutation.mutate(p);
    }

    // 15 发票信息查询接口
    // https://kapi.corp.kuaishou.com/project/8039/interface/api/844504
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/invoice',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    invoiceInfoMutation!: MutationResult<Record<any, any>, InvoiceInfoType>;

    async invoiceInfoMut(p: Record<any, any>) {
        await this.invoiceInfoMutation.mutate(p);
    }

    get invoiceInfo() {
        return (
            this.invoiceInfoMutation.data.data ?? {
                invoiceContentType: 1,
                invoiceType: 1,
                remainUpdateTimes: 1,
                updateEnable: false,
                updateUnableTips: '',
            }
        );
    }

    // 16 发票信息修改接口
    // https://kapi.corp.kuaishou.com/project/8039/interface/api/844512
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/invoice',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    invoiceInfoUpdateMutation!: MutationResult<Record<any, any>, any>;

    async invoiceInfoUpdateMut(p: Record<any, any>) {
        await this.invoiceInfoUpdateMutation.mutate(p);
    }

    // 获取白名单提现接口
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/wallet/withdraw/qrcode',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    getKconfMutation!: MutationResult<
        Record<any, any>,
        any
    >;

    async getKconf() {
        await this.getKconfMutation.mutate({});
    }

    get kconfInfo() {
        return this.getKconfMutation.data;
    }

    // 获取白名单提现金额数据接口
    @restMutation<GameFinanceModel>({
        url: '/portal/app/miniGame/payment/wallet/account',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    getMoneyMutation!: MutationResult<
        Record<any, any>,
        any
    >;

    async getMoney() {
        await this.getMoneyMutation.mutate({});
    }

    get moneyInfo() {
        return this.getMoneyMutation.data;
    }

}
